import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  title: 'Put title here',
  description: 'Put description here',
  showCrossDismissBtn: true,
  ctaText: 'CTA HERE',
  iconName: 'InfoIcon',
  state: 'lilac'
}, getTestId('CalloutWidgetContainer'));